if(!customElements.get('hero-arrow')) {
  customElements.define(
    'hero-arrow',
    class HeroArrow extends HTMLElement {
      constructor() {
        super();
        this.startTime = null;
        this.isAnimating = false;
        this.isUserScrolled = false;
        this.animatePulseOnLoad = true;
        this.heroParent = this.closest('.shopify-section');
        this.handleScroll = this.startAnimation.bind(this);
        window.addEventListener('scroll', () => this.isUserScrolled = true);
        this.addEventListener('click', this.scrollTo.bind(this));
        this.handleScroll();
      }

      scrollTo() {
        // Get the target scroll position from the dataset attribute
        const scrollTo = parseInt(this.dataset.animationDelay);
        if(scrollTo <= 0) return;

        // Retrieve the announcement bar height to add extra scroll space if available
        const announcementHeight = getComputedStyle(this.closest('html')).getPropertyValue('--announcement-height')?.trim();
        const scrollExtra = announcementHeight && announcementHeight !== undefined && announcementHeight !== null && announcementHeight !== '' ? parseFloat(announcementHeight) : 0;

        // Calculate the final scroll position based on dataset value and announcement height
        const scrollPosition = scrollTo > 0 ? scrollTo + scrollExtra : window.innerHeight / 2;

        // Scroll the window to the calculated position with a smooth scroll behavior
        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth'
        });
      }

      startAnimation() {
        this.isAnimating = true;
        this.startTime = performance.now();

        // Recursive function for the animation loop using requestAnimationFrame
        const runAnimation = (timestamp) => {
          // Calculate elapsed time since animation start
          const elapsedTime = timestamp - this.startTime;

          // Get the current vertical scroll position of the window
          const scrolledPx = window.scrollY;

          // Add class to trigger initial pulse animation on load if enabled
          if(this.animatePulseOnLoad) {
            this.heroParent.classList.add('hero-arrow-loaded');
          }

          // Add or remove 'remove-hero-arrow' class based on scroll position
          if(scrolledPx > parseInt(this.dataset.animationDelay)) {
            if(!this.heroParent.classList.contains('remove-hero-arrow') && !this.heroParent.classList.contains('hero-arrow-loaded')) {
              this.heroParent.classList.add('remove-hero-arrow');
            };
          } else {
            if(this.heroParent.classList.contains('remove-hero-arrow')) this.heroParent.classList.remove('remove-hero-arrow');
          }

          // Stop pulse animation if user scrolls manually, removing the 'hero-arrow-loaded' class
          if(this.isUserScrolled) {
            this.animatePulseOnLoad = false;
            this.heroParent.classList.remove('hero-arrow-loaded');
          }
          
          // Continue the animation loop
          requestAnimationFrame(runAnimation);
        };
      
        // Start the animation loop
        requestAnimationFrame(runAnimation);
      }
    }
  )
}